import { Grid, Typography } from "@mui/material";
import React from "react";
import { primary, secondary } from "../../../../themes/theme";

interface IProps {
  heading: string;
  description?: string;
}

const LayoutHeading: React.FC<IProps> = ({ heading, description }) => {
  return (
    <>
      <Grid
        container
        sx={{
          mt: { xs: 1, sm: 1, md: 3, lg: 3 },
          borderRadius: "10px",
          px: { xs: 1, sm: 1, md: 1, lg: 2 },
        }}
      >
        <Grid
          item
          xs={11}
          sm={12}
          md={12}
          lg={12}
          sx={{
            textAlign: "left",
            pl: { xs: 0, sm: 0, md: 8, lg: 8 },
            mt: { xs: 1, sm: 1, md: 9, lg: 9 },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontFamily: "Lato",
              color: primary[900],
              display: { xs: "none", md: "block" },
            }}
          >
            {heading}
          </Typography>
          <Typography
            paragraph
            sx={{
              fontFamily: "Ubuntu",
              color: secondary[600],
              display: { xs: "none", md: "block" },
            }}
          >
            {description ? (
              description
            ) : (
              <>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Sint
                dicta corrupti voluptatem quam ipsa dolores ipsum excepturi eos
                enim, expedita saepe molestias possimus iusto sed, molestiae
                natus maxime sed dolor sit molestias, odio, libero similique
                recusandae omnis ut at!
              </>
            )}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default LayoutHeading;
